import React, { Component } from "react";
import * as pageData from "./PageData";

export default class Wpq extends Component {
    static getDerivedStateFromProps(props, state) {
        if (state.index === props.content.index) {
            return null;
        }

        return {
            index: props.content.index,
            selectedOptionValue: pageData.nullOption
        };
    }

    constructor(props) {
        super(props);
        this.interceptClick = this.interceptClick.bind(this);
        this.optionChange = this.optionChange.bind(this);
        this.state = {
            index: 0,
            selectedOptionValue: pageData.nullOption
        };
    }

    componentDidMount() {
        this.afterUpdate();
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);
    }

    optionChange(value) {
        this.setState({ selectedOptionValue: value });
        this.props.clearDisableNext();
    }

    interceptClick(type) {
        if (type === "next") {
            this.props.next({ response: this.state.selectedOptionValue });
            return true;
        }

        return false;
    }

    render() {
        const p = this.props;
        const optionChange = this.optionChange;

        const progressStyle = {
            width: `${p.content.index * (100 / pageData.workProfileQuestionnaireTestPages)}%`
        };

        return (
            <div className="test-page-content-inner test-page-wpq">
                <div className="test-content">
                    {renderPractice(p, this.state, optionChange)}
                </div>
                <div className="progress">
                    <div className="progress-bar progress-bar-striped" role="progressbar" style={progressStyle} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" />
                </div>
            </div>
        );
    }
}

function renderPractice(props, state, optionChange) {
    const options = ["Totally Disagree", "Slightly Disagree", "Slightly Agree", "Strongly Agree"];

    return (
        <div className="test-content-inner">
            <div className="question">
                {props.content.question}
            </div>
            <h2 className="answer-title">Answer</h2>
            <div className="options">
                {renderOptions(options, props, state, optionChange)}
            </div>
        </div>
    );
}

function renderOptions(elems, props, state, optionChange) {
    const sourceIndex = props.content.index;

    return elems.map(function (elem, index) {
        return renderOption(elem, props, state, sourceIndex, index + 1, optionChange);
    });
}

function renderOption(elem, props, state, sourceIndex, optionValue, optionChange) {
    const id = `option${sourceIndex}-${optionValue}`;
    const checked = state.selectedOptionValue === optionValue;
    const disabled = props.waitingForSpeech ? 'disabled' : '';

    return (
        <div className="inputGroup" key={id}>
            <input id={id} type="radio" name="option" value={optionValue} checked={checked} onChange={() => optionChange(optionValue)} disabled={disabled} />
            <label htmlFor={id}><span><span /></span></label>
            <span className="option-text">{elem}</span>
        </div>
    );
}
